<template>
  <section class="model-section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">核心业务</h2>
        <p class="section-subtitle">覆盖人工智能全产业链</p>
      </div>
      
      <div class="accordions-container">
        <div 
          v-for="(service, index) in services" 
          :key="index"
          class="accordion-item" 
          :class="{ 'active': activeIndex === index }"
          @click="toggleAccordion(index)"
        >
          <div class="accordion-header">
            <div class="service-number">{{ (index + 1).toString().padStart(2, '0') }}</div>
            <div class="accordion-title-wrapper">
              <div class="service-icon">
                <i :class="service.icon"></i>
              </div>
              <h3 class="service-title">{{ service.title }}</h3>
            </div>
            <div class="accordion-arrow">
              <i class="fas fa-chevron-down"></i>
            </div>
          </div>
          <div class="accordion-content">
            <p class="service-desc">{{ service.description }}</p>
            <div class="service-features">
              <div v-for="(feature, i) in service.features" :key="i" class="feature-item">
                <div class="feature-icon"><i class="fas fa-check"></i></div>
                <span>{{ feature }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="glow-effects">
        <div class="glow-circle"></div>
        <div class="glow-circle secondary"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModelSection',
  data() {
    return {
      activeIndex: 0,
      services: [
        {
          title: 'AI大模型训练',
          icon: 'fas fa-robot',
          description: '采用业界领先的技术进行大规模模型训练与优化，为客户提供高性能、高准确率的AI模型。',
          features: [
            '定制化大模型训练方案',
            '高效模型微调和优化',
            '多领域专业知识库定制',
            '模型性能评估与调优'
          ]
        },
        {
          title: '定制化AIGC平台',
          icon: 'fas fa-magic',
          description: '为企业客户打造专属的AI生成内容平台，满足特定行业和场景需求，提升内容生产效率。',
          features: [
            '行业专属内容生成系统',
            '多模态内容创作辅助',
            '企业级权限与安全管理',
            '自定义模板与工作流程'
          ]
        },
        {
          title: '数据标注服务',
          icon: 'fas fa-tags',
          description: '提供高质量、高效率的数据标注服务，为AI模型训练提供可靠的数据基础，确保模型性能。',
          features: [
            '多种数据类型标注支持',
            '专业标注团队高效作业',
            '严格质量控制流程',
            '数据安全与隐私保护'
          ]
        },
        {
          title: '智能硬件开发',
          icon: 'fas fa-microchip',
          description: '研发高性能、高性价比的AI硬件产品，贴合群众生活需求，实现AI技术的实际应用落地。',
          features: [
            'AI芯片与算法优化',
            '智能家居与工业设备',
            '嵌入式系统开发',
            '硬件产品全生命周期服务'
          ]
        }
      ]
    }
  },
  methods: {
    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    }
  }
}
</script>

<style scoped>
.model-section {
  position: relative;
  padding: 6rem 0;
  background-color: #1a172d;
  overflow: hidden;
  min-height: 100vh;
}

.section-header {
  text-align: center;
  margin-bottom: 5rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #b59eff 0%, #9d6efd 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #b3b3cc;
  max-width: 600px;
  margin: 0 auto;
}

.accordions-container {
  max-width: 900px;
  margin: 0 auto;
  perspective: 1000px;
  position: relative;
  z-index: 10;
}

.accordion-item {
  background: rgba(40, 34, 62, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 15px;
  position: relative;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(157, 110, 253, 0.2);
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  transform-origin: top center;
}

.accordion-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(157, 110, 253, 0.2);
  border-color: rgba(157, 110, 253, 0.3);
}

.accordion-item.active {
  background: rgba(40, 34, 62, 0.9);
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 15px 40px rgba(157, 110, 253, 0.3);
  border-color: rgba(157, 110, 253, 0.5);
  z-index: 20;
}

.accordion-header {
  display: flex;
  align-items: center;
  padding: 1.5rem 2rem;
  transition: all 0.3s ease;
}

.accordion-title-wrapper {
  display: flex;
  align-items: center;
  flex: 1;
}

.service-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: rgba(157, 110, 253, 0.2);
  margin-right: 2rem;
  line-height: 1;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.accordion-item.active .service-number {
  color: rgba(157, 110, 253, 0.6);
}

.service-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #9D6EFD 0%, #E879F9 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  box-shadow: 0 5px 15px rgba(157, 110, 253, 0.3);
  transition: all 0.3s ease;
}

.accordion-item.active .service-icon {
  transform: scale(1.1);
  box-shadow: 0 8px 25px rgba(157, 110, 253, 0.4);
}

.service-icon i {
  font-size: 1.3rem;
  color: white;
}

.service-title {
  font-size: 1.3rem;
  color: #ffffff;
  font-weight: 600;
  margin: 0;
  transition: all 0.3s ease;
}

.accordion-item.active .service-title {
  color: #b59eff;
}

.accordion-arrow {
  margin-left: 1.5rem;
  color: rgba(255, 255, 255, 0.5);
  transition: all 0.3s ease;
}

.accordion-item.active .accordion-arrow {
  transform: rotate(180deg);
  color: #b59eff;
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  padding: 0 2rem;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
}

.accordion-item.active .accordion-content {
  max-height: 400px;
  padding: 0 2rem 2rem;
  opacity: 1;
}

.service-desc {
  font-size: 1rem;
  color: #b3b3cc;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.service-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  padding-top: 0.5rem;
  border-top: 1px solid rgba(157, 110, 253, 0.2);
}

.feature-item {
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  color: #b3b3cc;
}

.feature-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, #9D6EFD 0%, #E879F9 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.feature-icon i {
  font-size: 0.7rem;
  color: white;
}

.glow-effects {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  overflow: hidden;
}

.glow-circle {
  position: absolute;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(157, 110, 253, 0.3) 0%, rgba(157, 110, 253, 0) 70%);
  top: -10%;
  right: -10%;
  filter: blur(50px);
  animation: glow 15s ease-in-out infinite alternate;
}

.glow-circle.secondary {
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(232, 121, 249, 0.2) 0%, rgba(232, 121, 249, 0) 70%);
  bottom: -20%;
  left: -10%;
  animation: glow 20s ease-in-out 2s infinite alternate-reverse;
}

@keyframes glow {
  0% {
    transform: translate(0, 0) scale(1);
    opacity: 0.5;
  }
  100% {
    transform: translate(50px, 30px) scale(1.2);
    opacity: 0.3;
  }
}

@media screen and (max-width: 992px) {
  .accordion-header {
    padding: 1.25rem 1.5rem;
  }
  
  .service-number {
    font-size: 2rem;
    margin-right: 1.5rem;
  }
  
  .service-features {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 768px) {
  .section-title {
    font-size: 2rem;
  }
  
  .section-subtitle {
    font-size: 1rem;
  }
  
  .accordion-item {
    margin-bottom: 12px;
  }
  
  .accordion-header {
    padding: 1rem;
  }
  
  .service-number {
    font-size: 1.5rem;
    margin-right: 1rem;
  }
  
  .service-icon {
    width: 36px;
    height: 36px;
  }
  
  .service-title {
    font-size: 1.1rem;
  }
  
  .accordion-content {
    padding: 0 1rem;
  }
  
  .accordion-item.active .accordion-content {
    padding: 0 1rem 1.5rem;
  }
}

@media screen and (max-width: 576px) {
  .accordion-header {
    flex-wrap: wrap;
  }
  
  .service-number {
    width: 100%;
    text-align: left;
    margin-bottom: 0.5rem;
    margin-right: 0;
  }
  
  .accordion-title-wrapper {
    width: calc(100% - 20px);
  }
  
  .accordion-arrow {
    position: absolute;
    right: 1rem;
    top: 1rem;
  }
}
</style> 